<dialog [id]="modalId" class="modal" #modalEl>
  <div class="modal-box w-full max-w-md p-6 rounded-2xl">
    <button class="btn btn-sm btn-circle btn-ghost absolute right-2 top-2" (click)="close()">✕</button>
    <h2 class="text-lg font-semibold mb-1 text-primary">Create a custom tag</h2>
    <p class="text-sm text-base-content/70 mb-4">
      Defines a new post-analysis tag for your lab. Reuse an existing one from the picker before creating a new one.
    </p>

    <form [formGroup]="form" (ngSubmit)="submit()">
      <label class="block text-sm font-medium mb-1">
        <span><span class="text-error">*</span> Name</span>
        <input type="text" formControlName="name" class="input input-bordered w-full h-10 mt-1" placeholder="e.g. Resistance profile" />
      </label>

      <label class="block text-sm font-medium mt-3 mb-1">
        <span><span class="text-error">*</span> Data type</span>
        <select formControlName="data_type" class="select select-bordered w-full h-10 mt-1">
          <option *ngFor="let dt of dataTypes" [value]="dt.value">{{ dt.label }}</option>
        </select>
      </label>

      <!-- SELECT-only: option list + multi toggle -->
      <ng-container *ngIf="isSelect">
        <label class="block text-sm font-medium mt-3 mb-1"><span>Options</span></label>
        <div class="flex gap-2">
          <input
            #optionInput
            type="text"
            placeholder="Add an option..."
            class="input input-bordered flex-1 h-10"
            (keydown.enter)="$event.preventDefault(); addOption(optionInput)"
          />
          <button type="button" class="btn btn-sm h-10" (click)="addOption(optionInput)">Add</button>
        </div>
        <div *ngIf="options.length" class="mt-2 flex flex-wrap gap-1">
          <span
            *ngFor="let opt of options; let i = index"
            class="inline-flex items-center gap-1 px-2 py-1 rounded-full text-sm border border-base-300 bg-base-100"
          >
            {{ opt }}
            <button type="button" (click)="removeOption(i)" class="text-error hover:opacity-70 leading-none">✕</button>
          </span>
        </div>

        <label class="flex items-start gap-2 mt-3 text-sm">
          <input type="checkbox" formControlName="multiple_select" class="checkbox checkbox-sm mt-0.5" />
          <span>Allow multiple values to be selected</span>
        </label>
      </ng-container>

      <label class="flex items-start gap-2 mt-3 text-sm">
        <input type="checkbox" formControlName="is_private" class="checkbox checkbox-sm mt-0.5" />
        <span>
          Private (lab-only)
          <span class="block text-xs text-base-content/70">
            Values stay visible only to members of this lab and never appear in the data catalogue, CSV exports,
            datasets, or search. This is set once when the tag is created.
          </span>
        </span>
      </label>

      <p *ngIf="errorMessage" class="text-error text-xs mt-2">{{ errorMessage }}</p>

      <div class="flex justify-end gap-2 pt-4 border-t border-base-300 mt-4">
        <button type="button" class="btn btn-sm btn-ghost" (click)="close()">Cancel</button>
        <button type="submit" class="btn btn-sm btn-primary" [disabled]="form.invalid || submitting">
          {{ submitting ? 'Creating...' : 'Create tag' }}
        </button>
      </div>
    </form>
  </div>
</dialog>
